/**
 *
 * Asynchronously loads the component for ListItem
 *
 */

import { lazyLoad } from 'utils/loadable';

export const ListItem = lazyLoad(
  () => import('./index'),
  module => module.ListItem,
);
